import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  count?: number;
}

export function AddCardToBinderBindersInputSkeleton({ count = 6 }: Props) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} className="h-20 min-w-[170px]" />
      ))}
    </div>
  );
}
